import React, { useEffect } from 'react';
import './App.css';
import Layout from './layouts/Layout';
import AnonyLayout from './layouts/AnonyLayout';
import { menus, anonyMenus } from './layouts/menus';
import { useDispatch, useSelector } from "react-redux";
import { LOGIN, LOGOUT, CHATALL } from "./services/actions";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
    const mainEl = document.querySelector('[name="main"]');
    if (mainEl) mainEl.scrollTop = 0;
    const pageContainers = document.querySelectorAll('.page-container, .main-container, [name="main"] > div');
    pageContainers.forEach((el) => {
      if (el) el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}

function App() {
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let auth = useSelector((state) => state?.loginState?.auth)
  React.useEffect(() => {
    dispatch({ type: `${LOGIN}_AUTH`, payload: null, local: true });
    if (localStorage?.selectedTheme == "dark") {
      document.body.classList.add("dark")
    } else {
      document.body.classList.remove("dark")
    }
  }, [])

  const onLogout = React.useCallback(() => {
    if (auth?.token) {
      dispatch({ type: `${LOGOUT}_AUTH`, payload: null });
    }
    navigate("/");
  }, [auth?.token, dispatch, navigate]);

  React.useEffect(() => {
    if (!auth?.token) return;

    // 1. Cross-tab synchronization via BroadcastChannel
    let channel = null;
    try {
      if (typeof BroadcastChannel !== 'undefined') {
        channel = new BroadcastChannel('widelapse_auth_session');
        channel.postMessage({
          type: 'NEW_LOGIN',
          userId: auth?.id,
          sessionKey: auth?.session_key,
        });

        channel.onmessage = (event) => {
          if (event.data?.type === 'NEW_LOGIN' && event.data?.userId === auth?.id) {
            if (event.data?.sessionKey && auth?.session_key && event.data?.sessionKey !== auth?.session_key) {
              const msg = 'You have been logged out because this account was logged in from another tab or window.';
              sessionStorage.setItem('session_terminated_reason', msg);
              onLogout();
            }
          }
        };
      }
    } catch (e) {
      console.warn('BroadcastChannel error', e);
    }

    // 2. Storage event listener for cross-tab sync
    const handleStorageChange = (e) => {
      if (e.key === 'auth') {
        if (!e.newValue || e.newValue === 'null') {
          onLogout();
        } else {
          try {
            const newAuth = JSON.parse(e.newValue);
            if (newAuth?.id === auth?.id && newAuth?.session_key && auth?.session_key && newAuth?.session_key !== auth?.session_key) {
              const msg = 'You have been logged out because this account was logged in from another tab or window.';
              sessionStorage.setItem('session_terminated_reason', msg);
              onLogout();
            }
          } catch (err) {}
        }
      }
    };
    window.addEventListener('storage', handleStorageChange);

    // 3. API session_terminated event listener (fired when API returns 401)
    const handleSessionTerminated = (e) => {
      const msg = e?.detail?.message || 'Your session has ended because this account was logged in from another device or browser.';
      sessionStorage.setItem('session_terminated_reason', msg);
      onLogout();
    };
    window.addEventListener('session_terminated', handleSessionTerminated);

    // 4. Remote system heartbeat: check session status every 15 seconds
    const checkSession = async () => {
      const token = auth?.token;
      if (!token) return;
      try {
        const apiBase = (process.env.REACT_APP_URL || '/api/').replace(/\/+$/, '') + '/';
        const res = await axios.get(`${apiBase}session-status/`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (res.data?.is_success === false || res.data?.code === 401) {
          const msg = 'Your session has ended because this account was logged in from another device or browser.';
          sessionStorage.setItem('session_terminated_reason', msg);
          onLogout();
        }
      } catch (err) {
        if (err?.response?.status === 401) {
          const msg = err?.response?.data?.detail || err?.response?.data?.message || 'Your session has ended because this account was logged in from another device or browser.';
          sessionStorage.setItem('session_terminated_reason', msg);
          onLogout();
        }
      }
    };

    const intervalId = setInterval(checkSession, 15000);

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        checkSession();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      if (channel) channel.close();
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('session_terminated', handleSessionTerminated);
      document.removeEventListener('visibilitychange', handleVisibility);
      clearInterval(intervalId);
    };
  }, [auth?.token, auth?.session_key, auth?.id, onLogout]);

  React.useEffect(() => {
    if (auth?.token && !localStorage.getItem("auth")) {
      onLogout();
    }
  }, [auth?.token, onLogout]);
  let isloaded = false;
  React.useEffect(() => {
    if (auth?.token && !isloaded) {
      const eventSource = new EventSource(
        `https://demo.widelapse.com/api/messages/sse/${auth?.id}/`
      );
      eventSource.onopen = () => {
        console.log("Connection to server opened.");
        isloaded = true;
      };
      eventSource.onmessage = (event) => {

        if (event.data === "[DONE]") {
          // eventSource.close();
        } else {
          let fixed = event.data
            .replace(/'/g, '"') // replace single quotes with double quotes
            .replace(/\bFalse\b/g, "false")
            .replace(/\bTrue\b/g, "true");
          fixed = fixed.replaceAll("None", "null");
          let parsed = JSON.parse(fixed);
          console.log("running", parsed.length);
          //setMessages((prev) => [...prev, parsed]);
          dispatch({ "message": "", "type": CHATALL + "_SUCCESS", "data": parsed });
        }
      };

      eventSource.onerror = (err) => {
        console.error("SSE error:", err);
        eventSource.close();
      };

      // cleanup on unmount
      return () => {
        eventSource.close();
      };
    }
  }, []);

  return (<>

    <ScrollToTop />
    {auth?.token && <Layout menus={menus}
      onLogout={() => { onLogout() }}
      appName={<label style={{ fontWeight: 800 }} className="text-center">{"Widelapse Core"}</label>}
      ispushsidebar={true}
    />}
    {!auth?.token && <AnonyLayout menus={anonyMenus} />}
  </>
  );
}

export default App;
